module.exports = __webpack_public_path__ + "static/media/next.fe7ee5cb.svg";